var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.sendForm($event)
        }
      }
    },
    [
      _c("div", { staticClass: "container mb-4" }, [
        _c("div", { staticClass: "k-panel k-panel--grid" }, [
          _c(
            "div",
            { staticClass: "k-panel__body k-panel__body--2-3 k-border-right" },
            [
              _c("h3", { staticClass: "k-h-tertiary k-mb-30" }, [
                _vm._v("Základní údaje")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "k-form" }, [
                _c("div", { staticClass: "k-form__name-group" }, [
                  _c(
                    "div",
                    { staticClass: "k-form__name-group-item" },
                    [
                      _c("label", { staticClass: "k-form__label" }, [
                        _vm._v("Titul před")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.title_before,
                            expression: "form.title_before"
                          }
                        ],
                        staticClass: "k-form__input",
                        attrs: {
                          type: "text",
                          placeholder: "Zadejte titul před"
                        },
                        domProps: { value: _vm.form.title_before },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.form,
                              "title_before",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.form_errors.title_before
                        ? _c("field-error", [
                            _vm._v(
                              _vm._s(_vm.form_errors.title_before[0]) +
                                "\n                            "
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "k-form__name-group-item" },
                    [
                      _c("label", { staticClass: "k-form__label" }, [
                        _vm._v("Jméno uživatele")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.name,
                            expression: "form.name"
                          }
                        ],
                        staticClass: "k-form__input",
                        attrs: {
                          type: "text",
                          placeholder: "Zadejte jméno uživatele"
                        },
                        domProps: { value: _vm.form.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.form, "name", $event.target.value)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.form_errors.name
                        ? _c("field-error", [
                            _vm._v(_vm._s(_vm.form_errors.name[0]))
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "k-form__name-group-item" },
                    [
                      _c("label", { staticClass: "k-form__label" }, [
                        _vm._v("Titul za")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.title_after,
                            expression: "form.title_after"
                          }
                        ],
                        staticClass: "k-form__input",
                        attrs: {
                          type: "text",
                          placeholder: "Zadejte titul za"
                        },
                        domProps: { value: _vm.form.title_after },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.form,
                              "title_after",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.form_errors.title_after
                        ? _c("field-error", [
                            _vm._v(
                              _vm._s(_vm.form_errors.title_after[0]) +
                                "\n                            "
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "k-form__half-group" }, [
                  _c(
                    "div",
                    [
                      _c("label", { staticClass: "k-form__label" }, [
                        _vm._v("Pobočka zaměstnance")
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.branch_office_id,
                              expression: "form.branch_office_id"
                            }
                          ],
                          staticClass: "form-control k-choices--single",
                          attrs: { name: "choices-single-no-search" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.form,
                                "branch_office_id",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "option",
                            { attrs: { value: "", placeholder: "" } },
                            [_vm._v("Vyberte pobočku")]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.branchOffices, function(item, index) {
                            return _c(
                              "option",
                              { domProps: { value: index } },
                              [_vm._v(_vm._s(item))]
                            )
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.form_errors.branch_office_id
                        ? _c("field-error", [
                            _vm._v(
                              _vm._s(_vm.form_errors.branch_office_id[0]) +
                                "\n                            "
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("label", { staticClass: "k-form__label" }, [
                        _vm._v("Pracovní zařazení")
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.job_title_id,
                              expression: "form.job_title_id"
                            }
                          ],
                          staticClass: "form-control k-choices--single",
                          attrs: { name: "choices-single-no-search" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.form,
                                "job_title_id",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "option",
                            { attrs: { value: "", placeholder: "" } },
                            [_vm._v("Vyberte pracovní zařazení")]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.jobTitles, function(item, index) {
                            return _c(
                              "option",
                              { domProps: { value: index } },
                              [_vm._v(_vm._s(item))]
                            )
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.form_errors.job_title_id
                        ? _c("field-error", [
                            _vm._v(
                              _vm._s(_vm.form_errors.job_title_id[0]) +
                                "\n                            "
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("h3", { staticClass: "k-h-tertiary k-mt-50" }, [
                _vm._v("Kontaktní údaje")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "k-form__half-group" }, [
                _c(
                  "div",
                  [
                    _c("label", { staticClass: "k-form__label" }, [
                      _vm._v("Telefonní číslo")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.phone,
                          expression: "form.phone"
                        }
                      ],
                      staticClass: "k-form__input",
                      attrs: {
                        type: "text",
                        placeholder: "Zadejte telefonní číslo"
                      },
                      domProps: { value: _vm.form.phone },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.form, "phone", $event.target.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.form_errors.phone
                      ? _c("field-error", [
                          _vm._v(_vm._s(_vm.form_errors.phone[0]))
                        ])
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("label", { staticClass: "k-form__label" }, [
                      _vm._v("E-mailová adresa")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.email,
                          expression: "form.email"
                        }
                      ],
                      staticClass: "k-form__input",
                      attrs: {
                        type: "text",
                        placeholder: "Zadejte e-mailovou adresu"
                      },
                      domProps: { value: _vm.form.email },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.form, "email", $event.target.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.form_errors.email
                      ? _c("field-error", [
                          _vm._v(_vm._s(_vm.form_errors.email[0]))
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "k-panel__body k-panel__body--1-3  text-center" },
            [
              _c("h3", { staticClass: "k-h-tertiary k-mb-30" }, [
                _vm._v("Profil")
              ]),
              _vm._v(" "),
              _c("label", { staticClass: "k-form__label" }, [
                _vm._v("Fotografie")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "k-user" }, [
                _c(
                  "div",
                  { staticClass: "k-user__image" },
                  [
                    _c(
                      "transition",
                      { attrs: { name: "fade", mode: "out-in" } },
                      [
                        _vm.showSpinner
                          ? _c(
                              "div",
                              { key: "spinner" },
                              [
                                _c("vue-simple-spinner", {
                                  staticClass: "mt-5",
                                  attrs: {
                                    size: "medium",
                                    message: "Nahrávám fotografii..."
                                  }
                                })
                              ],
                              1
                            )
                          : _c("div", { key: "image" }, [
                              _c("img", {
                                staticClass: "k-user__image-el",
                                attrs: { src: _vm.image_src }
                              }),
                              _vm._v(" "),
                              _vm.form.image_name != null
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "k-user__image-remove",
                                      attrs: { title: "Odstranit fotografii" },
                                      on: { click: _vm.removeFile }
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            role: "img",
                                            width: "20",
                                            height: "20"
                                          }
                                        },
                                        [
                                          _c("use", {
                                            attrs: {
                                              fill: "currentColor",
                                              "xlink:href":
                                                "/images/spritesheet.svg#add"
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false"
                    }
                  ],
                  ref: "image",
                  attrs: { type: "file", accept: ".png, .jpg, .jpeg" },
                  on: { change: _vm.handleFileUpload }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "k-user__info" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "k-btn k-btn--primary-outline",
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.$refs.image.click()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                            Nahrát fotografii\n                        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "k-help-text" }, [
                      _vm._v(
                        "\n                            JPG nebo PNG, max. 5 MB\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.form_errors.image
                      ? _c("field-error", [
                          _vm._v(_vm._s(_vm.form_errors.image[0]))
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ])
            ]
          ),
          _vm._v(" "),
          _vm._m(0)
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "k-panel__footer justify-content-between align-items-center"
      },
      [
        _c("div", { staticClass: "k-panel__footer-btn" }, [
          _c("button", { staticClass: "k-btn k-btn--primary" }, [
            _vm._v("Uložit")
          ])
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }